
import {
  defineComponent, onMounted, onUnmounted, computed, reactive, ref,
} from 'vue';
import { useStore } from 'vuex';
// import HotelList from '@/components/HotelList.vue';
import Loading from '@/components/Loading.vue';
import Gallery from '@/components/Gallery.vue';
import Details from '@/components/Details.vue';
import Flights from '@/components/Flights.vue';
import Form from '@/components/Form.vue';
import Map from '@/components/Map.vue';
// import OfficeForm from '@/components/OfficeForm.vue';
// import {
//   mapState, mapMutations, mapGetters, mapActions,
// } from 'vuex';

export default defineComponent({
  name: 'Tour',
  components: {
    // HotelList,
    Loading,
    Map,
    Gallery,
    Details,
    Flights,
    Form,
    // OfficeForm,
  },
  setup() {
    const $store = useStore();
    const {
      isError,
      isLoading,
      priceString,
      context,
      hotelInfo, touristStringFrom, flightPrice, flightFuelCharge,
    } = $store.getters;
    const tour = computed(() => $store.state.tour);
    const isSent = computed(() => $store.state.isSent);
    const feedback = computed(() => $store.state.feedback);
    const hotel = computed(() => hotelInfo(tour.value.hotelcode));
    const relatedList = computed(() => $store.state.relatedList);

    const aboutRegion = computed(() => $store.state.initials.list[$store.state.cellIndex]);

    const departure = (window as {WTV_DEPARTURE?: boolean}).WTV_DEPARTURE;

    onMounted(() => {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    });
    onUnmounted(() => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    });

    const setTour = (newTour: unknown) => $store.commit('setTour', newTour);

    const reactiveData = reactive({
      tabSelected: 'hotel',
      tour,
    });
    const isSelectedTab = (tab: string) => reactiveData.tabSelected === tab;

    const wrap = ref({} as HTMLDivElement);
    // watchEffect(() => reactiveData.tour && (wrap.value).scroll(0, 0));

    const selectTab = (tab: string) => {
      reactiveData.tabSelected = tab;

      const e = window.event as Event;
      const type = (e.target as HTMLDivElement)?.dataset?.stats;
      if (type) {
        $store.dispatch('sendStats', {
          cell: $store.state.initials.list[$store.state.cellIndex],
          type: (e.target as HTMLDivElement)?.dataset?.stats,
        });
      }

      if (tab === 'order') {
        setTimeout(() => (document.querySelector('.wtv-form .wtv-form-submit') as Element).scrollIntoView({ behavior: 'smooth' }), 200);
      }

      if (tab === 'flights') $store.dispatch('actualizeDetail');
    };
    // data() {
    //   return {
    //     tabSelected: 'hotel',
    //   };
    // },
    // computed: {
    //   ...mapGetters([
    //     'isLoading',
    //     'touristStringFrom',
    //     'priceString',
    //     'flightPrice',
    //     'flightFuelCharge',
    //     'flightCurrency',
    //     'flightFuelChargeCurrency',
    //     'context',
    //   ]),
    //   ...mapState(['tour', 'hotel', 'sent', 'feedback']),
    //   isSelectedTab() {
    //     return (tab) => this.tabSelected === tab;
    //   },
    // },
    // methods: {
    //   ...mapMutations(['setTour']),
    //   ...mapActions(['actualizeDetail']),
    //   selectTab(tab) {
    //     this.tabSelected = tab;
    //     if (tab === 'flights') this.actualizeDetail();
    //   },
    // },
    return {
      // isInitialized,
      setTour,
      isError,
      isLoading,
      priceString,
      flightPrice,
      flightFuelCharge,
      touristStringFrom,
      context,
      tour,
      hotel,
      relatedList,
      aboutRegion,

      feedback,
      isSent,
      isSelectedTab,
      selectTab,
      departure,

      wrap,
    };
  },
});
